import React from "react";
import { IntlProvider } from "react-intl";
import { useLocale } from "./useLocale";

interface IntlProviderWrapperProps {
    children: React.ReactNode;
}

/**
 * Wraps the application with react-intl's `IntlProvider`, using the active
 * locale resolved by `useLocale()`.
 *
 * Must be rendered inside the Redux `<Provider>` so that `useLocale` can
 * read the saved locale preference from the store.
 *
 * No message catalog is provided at this stage — the provider is wired up
 * now so that `useIntl()` and `<FormattedMessage>` are available for future
 * translated strings without requiring a re-architecture.
 */
const IntlProviderWrapper = ({ children }: IntlProviderWrapperProps): React.JSX.Element => {
    const locale = useLocale();

    return (
        <IntlProvider locale={locale} defaultLocale="en-US">
            {children}
        </IntlProvider>
    );
};

export default IntlProviderWrapper;
